module.exports = __webpack_public_path__ + "static/media/sevis-logo.06438230.svg";